const initState = false;
const IsUserProviderReducer = (state = initState, action) => {
    switch(action.type) {
        case  'IsUserProvider' : return  action.payload ;
        default: return state;
    }
}
export default IsUserProviderReducer;